import { InternalLinkbox } from 'ui/components';

export const InternalLinkboxFeature: React.FC<Content.InternalLinkbox> = ({ content, settings }) => {
	const { heading, linkboxItems, ctaLink } = content?.properties ?? {};
	const { roundButtons, backgroundColor, textColor, buttonColor } = settings?.properties ??  {};

	return (
		<InternalLinkbox
			heading={heading}
			linkboxItems={linkboxItems?.map(({ content }) => {
				const { text, anchorLink } = content?.properties ?? {};

				return {
					text,
					anchorLink,
				};
			})}
			roundButtons={roundButtons}
			backgroundColor={backgroundColor}
			textColor={textColor}
			buttonColor={buttonColor}
			ctaLink={ctaLink}
		/>
	);
};
